import { render, staticRenderFns } from "./PrefsMenu.vue?vue&type=template&id=4a4e436a&scoped=true"
import script from "./PrefsMenu.vue?vue&type=script&lang=js"
export * from "./PrefsMenu.vue?vue&type=script&lang=js"
import style0 from "./PrefsMenu.vue?vue&type=style&index=0&id=4a4e436a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a4e436a",
  null
  
)

export default component.exports